import { useEffect, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import MemberList from "./MemberList";
import {
    setCurrentScheduleId,
    fetchMembers,
    setPeriods,
    addMemberToSelection,
    removeMemberFromSelection,
    clearMemberSelection
} from "../../stores/member/memberActions";

const Sidebar = (props) => {
    const dispatch = useDispatch();
    const initializedRef = useRef(false);

    // Get state from Redux store - memoize members to prevent new array reference on every render
    const membersById = useSelector(state => state.member.members_by_id || {});
    const members = useMemo(() => Object.values(membersById), [membersById]);
    const selectedMembers = useSelector(state => state.member.selected_members || []);
    const periods = useSelector(state => state.member.periods || []);

    useEffect(() => {
        // Only run once on mount
        if (!initializedRef.current) {
            dispatch(setCurrentScheduleId(props.scheduleId));
            dispatch(fetchMembers(props.url));
            dispatch(setPeriods(props.periods));
            initializedRef.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkKeyboard = (e) => e.ctrlKey || e.metaKey || e.shiftKey;

    useEffect(() => {
        if (props.readOnly) return;

        const $sidebarContainer = $(document).find(".sidebar");

        $sidebarContainer.off("click.members").on("click.members", ".member", function (e) {
            const element = e.currentTarget;
            const $element = $(element);
            const memberId = $element.data("member-id");
            let isSelected = $element.hasClass("selected");

            if (memberId) {
                if (!checkKeyboard(e)) {
                    dispatch(clearMemberSelection());
                    if (!isSelected) {
                        dispatch(addMemberToSelection(memberId));
                    }
                } else if (!isSelected) {
                    dispatch(addMemberToSelection(memberId));
                } else {
                    dispatch(removeMemberFromSelection(memberId));
                }
            } else if (!checkKeyboard(e)) {
                dispatch(clearMemberSelection());
            }
        });

        const $members = $sidebarContainer.find(".member");
        $members.draggable({
            revert: true,
            revertDuration: 0,
            helper: function (event) {
                const $draggedDiv = $("<div />", { class: "dragged_wrapper" });
                selectedMembers.forEach(function (memberId) {
                    const $member = $(`.sidebar .member[data-member-id="${memberId}"]`);
                    $draggedDiv.append(
                        $member
                            .clone(true)
                            .css({ width: $(event.currentTarget).outerWidth() })
                    );
                });
                return $draggedDiv;
            },
            appendTo: "body",
            start: function (event) {
                const $element = $(event.currentTarget);
                if (
                    $element.hasClass("ui-draggable") &&
                    !$element.hasClass("selected")
                ) {
                    return false;
                }
            },
        });

        // Cleanup event handlers on unmount
        return () => {
            if (props.readOnly) return;
            $sidebarContainer.off("click.members");
            $members.draggable("destroy");
        };
    }, [props.readOnly, selectedMembers, dispatch, members]);

    return (
        <MemberList members={members} periods={periods} />
    );
};

export default Sidebar;
